import MastersModel from '../Apis/Masters.js'
import Controller from './Controller.js';

export default class MastersController extends Controller {

    constructor() {
        super(new MastersModel());
    }

    async RequestNewMaster(data) {
        const res = await this.model.RequestNewMaster(data);
        return this.Poup(res);
    }
    async updateTeachers(data, headers = {}) {
        const res = await this.model.updateTeachers(data);
        return this.Poup(res);
    }
    timeLine() {
        return [

            {

                title: "الموافقة علي المقترح ",
                code: "approval_of_the_proposal",
                route: "ApprovalOfTheProposal",
                phases: [
                    {
                        title: "عنوان المقترح ",
                        code: "suggested_title",
                        type: "data",
                        accreditation : "supervisor"

                    },
                    {
                        title: "مجال البحث",
                        code: "research_field",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "فكرة عامة عن الموضوع ",
                        code: "general_idea_of_the_topic",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "موافقة القسم",
                        code: "department_approval",
                        type: "status",
                        accreditation : "chief_of_department"
                    },
                    {
                        title: "موافقة الكلية",
                        code: "college_approval",
                        type: "status",
                        accreditation : "colleage"
                    },
                ],
                icon: "fa-sitemap",
            },
            {

                title: "مرحلة هيكلة الخطة ",
                code: "plan_structuring_phase",
                route: "PlanStructuringPhase",
                phases: [
                    {
                        title: "رفع ملف هيكلة الخطة",
                        code: "upload_research_plan",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "اعتماد المشرف للخطة ",
                        code: "supervisor_approval_of_the_plan",
                        type: "status",
                        accreditation : "supervisor"
                    },
                    {
                        title: "اعتماد القسم للخطة",
                        code: "department_approval_of_the_plan",
                        type: "status",
                        accreditation : "chief_of_department"
                    },
                    {
                        title: "الدفاع عن هيكلة الخطة",
                        code: "defense_of_the_structuring_plan",
                        type: "online",
                        accreditation : "chief_of_department"
                    },
                    {
                        title: "قرار المشرف",
                        code: "supervisors_decision",
                        type: "decision",
                        accreditation : "supervisor"
                    },

                    {
                        title: "قرار المناقش الأول ",
                        code: "decision_of_the_first_debate",
                        type: "decision",
                        accreditation : "discussion_1"
                    },
                    {
                        title: "قرار المناقش الثاني  ",
                        code: "decision_of_the_second_debate",
                        type: "decision",
                        accreditation : "discussion_2"
                    },
                    {
                        title: "قرار رئيس الجلسة",
                        code: "decision_of_the_chairperson",
                        type: "decision",
                        accreditation : "chairman"
                    },
                    {
                        title: "قرار رئيس القسم ",
                        code: "decision_of_the_department_head",
                        type: "decision",
                        accreditation : "chief_of_department"
                    },
                    // {
                    //     title: " مراحل تتبع الدفاع  ",
                    //     code: "defense_tracking_phases",
                    // },
                ],
                icon: "fa-thermometer",
            },
            {

                title: "الدفاع عن الخطة – الدفاع الأول ",
                code: "first_defense",
                route: "FirstDefense",
                phases: [
                    {
                        title: "موعد الندوة ",
                        code: "symposium_date",
                        type: "online",
                        accreditation : "chief_of_department"
                    },
                    {
                        title: "رفع الفصول الاول",
                        code: "upload_the_three_seasons_1",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "رفع الفصول الثانى",
                        code: "upload_the_three_seasons_2",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "رفع الفصول الثالث",
                        code: "upload_the_three_seasons_3",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "الدفاع عن الخطة",
                        code: "defend_the_plan",
                        type: "online",
                        accreditation : "chief_of_department"
                    },
                ],
                icon: "fa-envelope-open",
            },
            {

                title: "التسليمات",
                code: "deliverables",
                route: "Deliverables",
                phases: [
                    {
                        title: "التسليم الاول",
                        code: "deliverables_1",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "التسليم الثاني",
                        code: "deliverables_2",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "التسليم الثالث",
                        code: "deliverables_3",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "التسليم الرابع",
                        code: "deliverables_4",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: "رفع النسخة النهائية للبحث",
                        code: "upload_the_final_version_of_the_search",
                        type: "data",
                        accreditation : "supervisor"
                    },
   
                 
                    {
                        title: "تقرير المشرف النهائي",
                        code: "final_supervisor_report",
                        type: "decision",
                        accreditation : "supervisor"
                    },
                    {
                        title: "موافقة القسم علي تقرير المشرف النهائي",
                        code: "final_supervisor_report_2",
                        type: "decision",
                        accreditation : "chief_of_department"
                    },
                    {
                        title: "موافقة الكلية علي تقرير المشرف النهائي",
                        code: "final_supervisor_report_3",
                        type: "decision",
                        accreditation : "colleage"
                    },
                    {
                        title: "موافقة الدراسات العليا علي تقرير المشرف النهائي",
                        code: "final_supervisor_report_4",
                        type: "decision",
                        accreditation : "graduate"
                    },
                    {
                        title: "موافقة النائب علي تقرير المشرف النهائي",
                        code: "final_supervisor_report_5",
                        type: "decision",
                        accreditation : "vice_dean"
                    },
                    
                    {
                        title: "إحالة البحث للتأكد من مطابقة المواصفات الفنية",
                        code: "refer_the_search_to_ensure_compliance_with_the_technical_specifications",
                        type: "status",
                        accreditation : "graduate"
                    },
                    {
                        title: "إحالة البحث لبرنامج كاشف السرقات العلمية والاقتباسات",
                        code: "referring_research_to_the_scientific_theft_and_quotation_detector_program",
                        type: "status",
                        accreditation : "graduate"
                    },
                   
                ],
                icon: "fa-desktop",
            },
            {

                title: "الدفاع عن جاهزية البحث – الدفاع الثاني  ",
                code: "second_defense",
                route: "SecondDefense",
                phases: [
                 
                    {
                        title: "الدفاع عن جاهزية البحث ",
                        code: "research_readiness_defense",
                        type: "online",
                        accreditation : "chief_of_department"
                    },
                    {
                        title: "لجنة تقييم الدفاع عن جاهزية البحث ",
                        code: "research_readiness_defense_evaluation_committee",
                        type: "status",
                        accreditation : "supervisor"
                    }
                ],
                icon: "fa-desktop",
            },
            {

                title: "المناقشة ",
                code: "discussion",
                route: "Discussion",
                phases: [
                    {
                        title: "الأطروحة ",
                        code: "thesis",
                        type: "data",
                        accreditation : "supervisor"
                    },
                    {
                        title: " إعتماد الإدارة العلمية ",
                        code: "adoption_of_scientific_management",
                        type: "status",
                        accreditation : "graduate"
                    },
                    
                    {
                        title: "تشكيل لجنة المناقشة",
                        code: "formation_of_the_discussion_committee",
                        type: "status",
                        accreditation : "chief_of_department"
                    },
                   
                ],
                icon: "fa-list-ol",
            },
            {

                title: "التخرج ومنح الدرجة العلمية  ",
                code: "graduation",
                route: "Graduation",
                phases: [
                    {
                        title: "اعتماد القسم ",
                        code: "graduation_department_approval",
                        type: "status",
                        accreditation : "chief_of_department"
                    },
                    {
                        title: "اعتماد الكلية",
                        code: "graduation_college_accreditation",
                        type: "status",
                        accreditation : "colleage"
                    },
                    {
                        title: "الدراسات العليا",
                        code: "graduation_graduate_studies",
                        type: "status",
                        accreditation : "graduate"
                    },
                    { 
                        title: "المجلس الأكاديمي ",
                        code: "graduation_academic_council",
                        type: "status",
                        accreditation : "vice_dean"
                    },
                ],
                icon: "fa-stamp",
            },
        ];
    }
    decision() {
        return [
            {
                title: "رفض",
                id: 0,
                variant: "light-danger"
            },
            {
                title: "قبول",
                id: 1,
                variant: "light-success"
            },
            {
                title: "قبول مع التعديل دون إعادة الدفاع ",
                id: 2,
                variant: ""
            },
            {
                title: "قبول مع التعديل مع إعادة الدفاع ",
                id: 3,
                variant: ""
            },
        ];
    }

}